import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=aa511636"
import script from "./ReportDetail.vue?vue&type=script&lang=ts"
export * from "./ReportDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports